<template>
  <side-modal @close="closeModal" :width="width">
    <template #header>
      <div :class="$style.header">
        <h2>{{ $t(i18n.title) }}</h2>
        <icon
          @click.native="closeModal"
          :class="$style.closeIcon"
          icon="cross"
        />
      </div>
    </template>

    <change-address-form @close="closeModal"></change-address-form>

    <template #footer><span></span></template>
  </side-modal>
</template>

<script>
import {Components, Utils} from "@bvm/core";
import { Icon } from "@bvm/forms";

const i18nBuilder = new Utils.I18n.I18nBuilder("change_address_modal")
        .add("title");

export const messageKeys = i18nBuilder.getKeys();

export default {
  name: "change-address-form-modal",
  components: {
    "side-modal": Components.SideModal,
    "change-address-form": () => import("./ChangeAddressForm"),
    Icon
  },
  props: {
    width: {type: String, default: "400px"}
  },
  data() {
    return {
      i18n: i18nBuilder.getData()
    };
  },
  methods: {
    closeModal() {
      this.$emit("close");
    }
  }
};
</script>

<style module lang="scss">
.header {
  display: flex;
  padding: 1rem 1rem;
  border-bottom: 1px solid #ececec;
  margin: 0 30px;
  align-items: center;
  justify-content: space-between;

  h2 {
    margin: 0;
  }
}

.closeIcon {
  color: #35ab7d;
  font-size: 2em;
  cursor: pointer;
}
</style>
